// extracted by mini-css-extract-plugin
export var centerText = "_6l-8";
export var container = "_6l-0";
export var doughnutContainer = "_6l-7";
export var legend = "_6l-a";
export var legendItemColorDisplay = "_6l-b";
export var legendItemLabel = "_6l-d";
export var legendItemValue = "_6l-c";
export var lg = "_6l-5";
export var maxWidth = "_6l-9";
export var md = "_6l-4";
export var responsive = "_6l-6";
export var sm = "_6l-3";
export var xs = "_6l-2";
export var xxs = "_6l-1";